import { useEffect, useState } from 'react'
import { convertCallDurationNoMilliseconds } from '~/utils/formatter'

export const useCallDuration = (startTime?: Date | null) => {
  const [callDuration, setCallDuration] = useState<string>('0:00')

  useEffect(() => {
    const updateCallDuration = () => {
      if (!startTime) {
        return
      }
      const callDurationInSeconds =
        (new Date().getTime() - startTime.getTime()) / 1000
      const callDurationString = convertCallDurationNoMilliseconds(
        callDurationInSeconds,
      )
      setCallDuration(callDurationString)
    }

    const interval = setInterval(() => updateCallDuration(), 1000)
    return () => clearInterval(interval)
  }, [startTime])

  return callDuration
}
